@if (item.dietary?.allergens?.length) {
  <div class="flex flex-wrap gap-1 py-1">
    @for (allergen of item.dietary!.allergens; track allergen) {
      <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="chipClasses(allergen)">
        {{ allergen }}
      </span>
    }
  </div>
} @else {
  <span>—</span>
}
